module.exports = __webpack_public_path__ + "img/accumulated_distance.b9c7ee52.svg";